import { Service } from '@/tools'
export class IntoAndManagementService<T extends TOrder.IntoAndManagement> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TOrder.IntoAndManagement}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }

  /**
   * 功能：即进即发订单列表
   */
  querySupplierInvoicePageExternal = (
    data: T['ApiQuerySupplierInvoicePageExternal']['req']
  ): Promise<T['ApiQuerySupplierInvoicePageExternal']['res']> => this.post2('v1/ApiQuerySupplierInvoicePageExternal', data)

  /**
   * 功能：即进即发订单明细列表
   */
  immediateProcessingList = (data: T['ApiImmediateProcessingList']['req']): Promise<T['ApiImmediateProcessingList']['res']> =>
    this.post2('v1/ApiImmediateProcessingList', data)
}
